import { useLang } from "@/context/LanguageContext";
import { IMAGES } from "@/data/images";
import { PageHero } from "@/components/PageHero";
import { PhotoCard, CardGrid } from "@/components/Cards";

export default function Technologies() {
  const { content } = useLang();
  const { technologiesPage } = content;
  return (
    <>
      <PageHero label={technologiesPage.title} title={technologiesPage.heading} intro={technologiesPage.intro} image={IMAGES.technologiesPage} />
      <section className="bg-white" data-testid="technologies-grid-section">
        <div className="container-x pt-8 pb-20 md:pt-10 md:pb-28">
          <CardGrid cols="sm:grid-cols-2 lg:grid-cols-3" className="gap-y-14">
            {technologiesPage.sections.map((t) => (
              <PhotoCard key={t.slug} to={`/technologies/${t.slug}`} image={IMAGES.technologies[t.slug]} title={t.title} text={t.text} cta={t.cta} testid={`tech-card-${t.slug}`} />
            ))}
          </CardGrid>
        </div>
      </section>
    </>
  );
}
